import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import PatResultType from "../enums/pat-result-type";

export default class PatCompleted extends Fragment {
    constructor() {
        super();
        this.result = PatResultType.GOOD.code;
    }

    summarize(summaryContext) {
        const message = "was good";

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }
}
